import React from 'react'

const Footer = () => {
  return (
    <footer className=' bg-black mt-4 px-3 pb-16'>
         <FooterContent header={"Payment Methods"} w={400} img={"payment"} />
         <div className=' flex mt-3 gap-[10px] pb-4 border-b border-gray-700'>
         <FooterContent header={"responsible gaming"} w={100} img={"gaming"} />
         <FooterContent header={"community websites"} w={200} img={"socials"} />
         </div>
         <div className=' flex  mt-3 pb-4 border-b border-gray-700'>
         <FooterContent header={"gaming license"} w={100} img={"license"} />
         <FooterContent header={"App Download"} w={100} img={"app"} />
         </div>

         <div className=' text-subtle font-custom mt-3 pb-4 border-b border-gray-700'>
            <h2 className=' text-[13px] font-bold '>
            Top Betting Exchange Sites Bangladesh, India & South East Asia
            </h2>
            <p className=' text-[13px] leading-4'>
            A betting exchange is practically an online tool that is designed for gamblers to bet directly against each other and not involve any of the traditional bookmakers. Cricket Betting indicates two ways of betting in a cricket match. The first one is to bet on the overall outcome of a live cricket match. The other one is based on the live cricket score of a team in the first 6 overs. 
            </p>
            <p className='text-[13px] leading-4'> 
            Online betting has developed as a booming industry in South East Asia especially in Bangladesh and India, where the bettors get to choose from an exciting range of Top Betting Exchange Sites in Bangladesh, India and others South East Asia Region.
            If you find this interesting and are in search of a reliable and safe Cricket Betting Sites Bangladesh and India, then you should enrol with us. Baji is a reputed online gambling site in the entire Asia. We focus on not only cricket predictions but also other exciting online gaming products.
            </p>
         </div>

         <div className=' mt-3 pb-4 flex gap-3 items-center'>
            <img src="/new_img/logo.png" alt="" width={70} />
            <div className='text-xs text-subtle '>
                <h2 className=' font-bold text-[15px]'>Best Quality Platform</h2>
                <p className=' mt-1 text-[14px]'>@ 2024 BaziBuzz copyrights. All Rights Reserve</p>
            </div>
         </div>
         
    </footer>
  )
}

export default Footer

const FooterContent = ({header,w, img, social})=>{
    return <div className=" w-full">
            <h2 className=' text-header capitalize font-medium text-[15px] '>{header}</h2>
           { img && <div className=' mt-2'>
                <img width={w} src={`/new_img/${img}.png`} alt="" />
            </div>}
            {social && <div>
                
                </div>}
        </div> 
}

const OldFooter = ()=>{
    return    <div>
<div className="container display_none">
<div className="row">
<div id="supportWrap" className="support-wrap d-flex justify-content-center mt-5">
        <div className="support-service">
            
            <a id="support_whatsapp" href="#" className="support-whatsapp"></a>
            
            
            
            
            
            
            
            <a id="support_facebook" href="#" className="support-fb open"></a>
            
            
            
            
        </div>

        <div className="support-info">
            
            <div id="supportDetail_whatsapp" className="support-detail">
                <a href="https://api.whatsapp.com/send?phone=442070974844">+442070974844 </a>
                
                <a href="https://api.whatsapp.com/send?phone=60172769682">+60172769682</a>
                
				
            </div>
            
            
            
            
            
            
            
            <div id="supportDetail_facebook" className="support-detail open">
                <a href="https://www.facebook.com/groups/9wickets" target="_blank">www.facebook.com/groups/9wickets</a>
            </div>
            
            
            
            
        </div>
    </div>
</div>
</div>


    <div className="power-wrap mt-3 display_none">
					
					
					
					
					
					<p>9wicketslive is operated by Sky Infotech N.V. a limited liability company incorporated under the laws of Curacao with
						company Registration number 152377 with registered office at Abraham de Veerstraat 9 , Curacao P.O Box 3421 and is licensed
						and regulated by the Curacao authority as the regulatory body responsible holding a (Sub-license with License number 365/JAZ
						Sub-License GLH- OCCHKTW0707072017 granted on 6.07.2017).
						<br/>
						Players are requested not to contact any untrusted sources for 9wickets.live accounts as this is an online site and they can only
						register independently without any agents. Only deposit through the account details generated by the system or provided by our
						official support team.
					</p>
					
				
				
				</div>
    </div>
}